import type { SVGProps } from "react";

export default function EmptyDashboardsIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_15909_29577)">
        <g filter="url(#filter0_d_15909_29577)">
          <path
            d="M9.99707 26.0003C9.99707 17.1637 17.1605 10.0003 25.9971 10.0003C34.8336 10.0003 41.9971 17.1637 41.9971 26.0003C41.9971 34.8369 34.8336 42.0003 25.9971 42.0003C17.1605 42.0003 9.99707 34.8369 9.99707 26.0003Z"
            fill="#515047"
          />
        </g>
        <g filter="url(#filter1_d_15909_29577)">
          <path
            d="M53.9963 69.9976C53.9963 61.1612 61.1599 53.9976 69.9963 53.9976C78.8327 53.9976 85.9963 61.1612 85.9963 69.9976C85.9963 78.834 78.8327 85.9976 69.9963 85.9976C61.1599 85.9976 53.9963 78.834 53.9963 69.9976Z"
            fill="#515047"
          />
        </g>
        <g filter="url(#filter2_d_15909_29577)">
          <path
            d="M85.9963 26.0003C85.9963 18.4578 85.9963 14.6866 83.6531 12.3435C81.3099 10.0003 77.5387 10.0003 69.9963 10.0003C62.4539 10.0003 58.6827 10.0003 56.3395 12.3435C53.9963 14.6866 53.9963 18.4578 53.9963 26.0003C53.9963 33.5428 53.9963 37.314 56.3395 39.6571C58.6827 42.0003 62.4539 42.0003 69.9963 42.0003C77.5387 42.0003 81.3099 42.0003 83.6531 39.6571C85.9963 37.314 85.9963 33.5428 85.9963 26.0003Z"
            fill="#F5A801"
          />
        </g>
        <g filter="url(#filter3_d_15909_29577)">
          <path
            d="M41.9971 69.9976C41.9971 62.4552 41.9971 58.684 39.6539 56.3408C37.3108 53.9976 33.5395 53.9976 25.9971 53.9976C18.4546 53.9976 14.6833 53.9976 12.3402 56.3408C9.99707 58.684 9.99707 62.4552 9.99707 69.9976C9.99707 77.54 9.99707 81.3112 12.3402 83.6544C14.6833 85.9976 18.4546 85.9976 25.9971 85.9976C33.5395 85.9976 37.3108 85.9976 39.6539 83.6544C41.9971 81.3112 41.9971 77.54 41.9971 69.9976Z"
            fill="#F5A801"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_15909_29577"
          x="-26.0029"
          y="-21.9997"
          width="104"
          height="104"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="18" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15909_29577"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15909_29577"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_15909_29577"
          x="17.9963"
          y="21.9976"
          width="104"
          height="104"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="18" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15909_29577"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15909_29577"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_15909_29577"
          x="17.9963"
          y="-21.9997"
          width="104"
          height="104"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="18" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15909_29577"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15909_29577"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_15909_29577"
          x="-26.0029"
          y="21.9976"
          width="104"
          height="104"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="18" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15909_29577"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15909_29577"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_15909_29577">
          <rect width="96" height="96" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
